import { TextButton } from '@wix/design-system';
import { dataHooks } from '../../utils/constants';
import useMarketplaceHeaderBi, {
  BI_CLICK_DATA,
  BI_CLICK_TYPES,
  IMPHeaderPageName,
} from '@components/Hooks/useMarketplaceHeaderBi';

interface MenuLinkProps {
  pageName: IMPHeaderPageName;
  title: string;
}

const JoinMarketplaceLink = ({
  pageName,
  title,
  marketplaceUrlPrefix,
}: MenuLinkProps & { marketplaceUrlPrefix: string }) => {
  const { reportClick } = useMarketplaceHeaderBi({ pageName });

  return (
    <TextButton
      dataHook={dataHooks.joinLink}
      as="a"
      weight="normal"
      skin="dark"
      href={`${marketplaceUrlPrefix}/join`}
      onClick={() => {
        reportClick({
          clickType: BI_CLICK_TYPES.profileDropdownMenu,
          clickData: BI_CLICK_DATA.getHired,
        });
      }}
    >
      {title}
    </TextButton>
  );
};

export default JoinMarketplaceLink;
